import { CaseStudy } from '../../types';

export const cashCanvas: CaseStudy = {
  id: '2',
  title: 'Cash Canvas',
  category: 'Visual Expense Tracking',
  imageUrl: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=1200&auto=format&fit=crop',
  description: "Finance doesn't have to be gray. Cash Canvas turns your spending habits into a visual masterpiece. It uses generative patterns to represent your budget health, making personal finance an engaging, artistic ritual.",
  screenshots: [
    'https://images.unsplash.com/photo-1543286386-713bdd548da4?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=1200&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1556742044-3c52d6e88c62?q=80&w=800&auto=format&fit=crop'
  ]
};